import {
  Box,
  Button,
  Divider,
  Flex,
  Input,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import AlertModal from "../../Modals/AlertModal";
import {
  getEditAssumptionsApi,
  updateEditAssumptionsApi,
} from "./services/editAssumptionServices";
import { mixpanelTrackButton } from "../../utils/mixpanelFunctions";

export const EditAssumptions = () => {
  const toast = useToast();
  const [enableEdit, setEnableEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editAssumptionsData, setEditAssumptionsData] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const order = {
    general: 1,
    "Coke Chinese": 2,
    "Coke Colombian": 3,
    "Coal Anthracite": 4,
  };
  const handleChange = (e, category) => {
    let { name, value } = e.target;
    value = isNaN(parseFloat(value)) ? "" : parseFloat(value);
    setEditAssumptionsData((prev) => {
      let tempData = {
        ...prev,
        [category]: { ...prev[category], [name]: value },
      };
      //   console.log(tempData);
      return tempData;
    });
  };

  const handleClick = () => {
    enableEdit ? onOpen() : setEnableEdit((prev) => !prev);
    mixpanelTrackButton("assumptions",enableEdit ? "save" : "enable editing")
  };

  const validateConstraints = (tempAssumptions) => {
    let validationStatus = { status: true };
    // nested loops to iterate in objects
    Object.keys(tempAssumptions).forEach((category) => {
      Object.keys(tempAssumptions[category]).forEach((item) => {
        if (
          tempAssumptions[category][item] === undefined ||
          tempAssumptions[category][item] === ""
        ) {
          validationStatus = {
            message: `Please fill the value of ${item}`,
            status: false,
          };

          // break out of both loops
          validationStatus.status = false;
          return;
        }
      });

      // If condition met, break out of the outer loop
      if (!validationStatus.status) {
        return;
      }
    });

    return validationStatus;
  };

  const handleConfirmEdit = () => {
    let { message, status } = validateConstraints(editAssumptionsData);
    console.log(status);
    if (status === false) {
      toast({
        title: "Bounds not satisfied",
        status: "error",
        isClosable: true,
        description: message,
        duration: 5000,
      });
      return;
    }
    //   make a post/patch req to update the constraint in be
    updateEditAssumptionsApi(editAssumptionsData)
      .then((res) => {
        console.log(res);
        getEditAssumptionsApi(setLoading).then((res) => {
          console.log(res);
          setEditAssumptionsData((prev) => res);
          setEnableEdit((prev) => !prev);
          if (res.status === true) {
            toast({
              title: res.message,
              status: "success",
              isClosable: true,
              // description: res.message,
              duration: 3000,
            });
          }
        });
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: "Error while updating",
          status: "error",
          isClosable: true,
          description: "Please try again",
          duration: 3000,
        });
      });
  };

  const handleCancelEdit = () => {
    getEditAssumptionsApi(setLoading)
      .then((res) => {
        console.log(res);
        setEditAssumptionsData((prev) => res);
        setEnableEdit((prev) => !prev);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //   to load data on initial mount
  useEffect(() => {
    getEditAssumptionsApi(setLoading)
      .then((res) => {
        console.log(res);
        setEditAssumptionsData((prev) => res);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      {loading ? (
        <div className="flex w-full h-[60vh] items-center justify-center">
          <Spinner size={"xl"} />
        </div>
      ) : (
        <Box w="95%" mx="auto">
          <Box w="100%" mt="20px">
            <Flex w="98%" direction="column" mb="1rem" justify="right">
              <Button
                p="0"
                colorScheme="blue"
                w="150px"
                type="submit"
                onClick={handleClick}
                fontSize="12px"
              >
                {enableEdit ? "SAVE" : "ENABLE EDITING"}
              </Button>
            </Flex>
            <AlertModal
              isOpen={isOpen}
              onOpen={onOpen}
              onClose={onClose}
              title="Upadate assumptions"
              body="Are you sure? You want to change these assumptions"
              colorScheme="red"
              onSubmit={handleConfirmEdit}
              onCancel={handleCancelEdit}
            />
            <TableContainer>
              <Table size="sm" colorScheme="gray">
                <Thead bg="#1a174e" borderColor="#1a174e">
                  <Tr>
                    <Th color="white" p={0} textAlign="center">
                      Constraint
                    </Th>
                    <Th color="white" textAlign="center">
                      Value
                    </Th>
                  </Tr>
                </Thead>
                <Tbody border="2px solid #e2e8f0">
                  {editAssumptionsData &&
                    Object.keys(editAssumptionsData)
                      ?.sort((a, b) => order[a] - order[b])
                      ?.map((category, categoryIdx) => (
                        <React.Fragment key={categoryIdx}>
                          <Tr>
                            <Td
                              textAlign="center"
                              p="10px"
                              colSpan={2}
                              fontSize="15px"
                              color="#1a174e"
                            >
                              <Flex
                                align="center"
                                justify="center"
                                gap="1rem"
                                w="100%"
                              >
                                <Divider border="2px solid #1a174e" w="100%" />
                                <Text fontWeight="500" className="uppercase">
                                  {category}
                                </Text>
                                <Divider border="2px solid #1a174e" w="100%" />
                              </Flex>
                            </Td>
                          </Tr>
                          {Object.keys(editAssumptionsData[category])
                            ?.sort()
                            ?.map((element, index) => (
                              <Tr key={index} border="2px solid #e2e8f0">
                                <Td p={2}>{element?.split("_")?.join(" ")}</Td>
                                <Td p={0} justify="center" textAlign="center">
                                  <Input
                                    type="number"
                                    name={element}
                                    placeholder={element}
                                    w="50%"
                                    h="100%"
                                    p="4px"
                                    m="auto"
                                    borderRadius={0}
                                    value={
                                      editAssumptionsData?.[category]?.[element]
                                    }
                                    disabled={!enableEdit}
                                    onChange={(e) => handleChange(e, category)}
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "ArrowUp" ||
                                        e.key === "ArrowDown"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    // Add the passive option to remove the passive flag
                                    onWheel={(e) => e.target.blur()}
                                    onScroll={(e) => e.target.blur()}
                                  />
                                </Td>
                              </Tr>
                            ))}
                        </React.Fragment>
                      ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      )}
    </>
  );
};
